module.exports = __webpack_public_path__ + "html/main-landing_9d3d20c6f563a21f46b69e3bca8edb0f.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing/main-landing.html
// module id = rVl+
// module chunks = 38